module.exports = "https://s91588.cdn.ngenix.net/microcredits-frontend/_next/static/images/ebsEsiaNumbers-3f950de2d37276d1afb49647590e6866.png";